import { useApi } from "utils"
import { useState } from "react"
import moment from "moment"
import toast from "react-hot-toast"
import { Button, DateInput, Modal } from "components"
import { ApprovalPaymentBillServiceSchema } from "../types"
import { UpdatePaymentBillService } from "../../PaymentBillService/UpdatePaymentBillService"

type ModalApprovePaymentBillServiceProps = {
  data: ApprovalPaymentBillServiceSchema 
  refetch: () => void 
  toggle: () => void
}

export const ModalApprovePaymentBillService = ({ data, refetch, toggle }: ModalApprovePaymentBillServiceProps) => {	
  const api = useApi()
  const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"))

  const onSubmit = (date: string, status: number) => {
    return new Promise<void>((resolve) => {
      toast.promise(api.post(`/paymentbill/approve?payment_bill_id=${data?.payment_bill_id}&approval_status=${status}&approve_date=${date}`), {
        loading: "Loading...",
        success: (res) => res.data.message,
        error: (err) => err.response.data.message ?? err.response.message 
      })
      .then(() => {
        refetch()
        toggle()
      })
      .catch(() => {})
      .finally(resolve)
    })
  }

  return (
    <Modal isdarktitle isOpen title="APPROVE PAYMENT BILL SERVICE" closeModal={toggle}>
      <Modal.Body>
        <UpdatePaymentBillService bill_id={data?.payment_bill_id} disable />
      </Modal.Body>

      <Modal.Footer className="flex md:flex-row flex-col justify-between md:items-end gap-3">
        <DateInput
          placeholderText="Select Date"
          selected={moment(date).toDate()}
          className="w-full"
          label="APPROVAL DATE"
          onChange={(date) => {
            const selectDate = moment(date).format("YYYY-MM-DD")
            setDate(selectDate)
          }}
        />

        <section className="flex gap-3">
          <Button onClick={toggle}>CANCEL</Button>
          <Button color="error" onClick={() => onSubmit(date, 3)}>REJECT</Button>
          <Button color="primary" onClick={() => onSubmit(date, 4)} >APPROVE</Button>
        </section>
      </Modal.Footer>
    </Modal>
  )
}